import { useAccount } from 'wagmi'
import useSWR from 'swr'
import { useLidoSDK, useGasFeeUSD } from '.'
import { useDebounce } from '~/hooks'
import { FALLBACK_WITHDRAWAL_REQUEST_CLAIM_GAS_LIMIT } from '../constants'
import { RequestStatusClaimable } from '../Withdrawal/types'

export const useClaimGasFee = (requests: RequestStatusClaimable[]) => {
  const { address: account } = useAccount()
  const { withdraw } = useLidoSDK()
  const requestCount = requests.length || 1
  const debouncedSortedSelectedRequests = useDebounce(requests, 2000)

  const { data } = useSWR(
    [
      'lido-withdrawal-claim-gas-limit',
      debouncedSortedSelectedRequests.map((r) => ({
        id: r.id.toString(),
        hint: r.hint.toString(),
      })),
      account,
    ],
    () =>
      withdraw.claim.claimRequestsEstimateGas({
        requestsIds: debouncedSortedSelectedRequests.map((r) => r.id),
        hints: debouncedSortedSelectedRequests.map((r) => r.hint),
      }),
  )

  const gasLimit =
    data ?? FALLBACK_WITHDRAWAL_REQUEST_CLAIM_GAS_LIMIT * BigInt(requestCount)

  const { gasFee, gasFeeUSD } = useGasFeeUSD(gasLimit)

  return { gasFee, gasFeeUSD }
}
